function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CssContainer } from "../../components/container";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import { hasTenantFeature } from "../../functions/tenant-features";
import { getGlobalRange, setGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { EmailHeader } from "../email-automation/email-header";
import { api, audienceApi, normalizeLists, qs, errMsg, toast, num, money, rangeToApi, railLabel, statusLabel, parseMaybe, asDate, dateTime, GUARD, refreshGuard, guardState, idStr, canArchive, canDelete, permanentDelete, archivedFrom } from "./api";

/*
 * Email → Campaigns (Email redesign 2026-10-09, mockup Main): the shared Email header, four totals
 * (Sent / Opened / Clicked / Sales from GET stats/overview, compared with the window before only when
 * that window has data), status pills (All · Drafts · Scheduled · Sent) + search, and one card per
 * campaign from GET campaigns (newest first). Outreach programs live in their own tab, not here.
 *
 * Row actions (2026-10-05) sit in each card's ··· menu: Duplicate · Archive (Sent / Canceled / Draft /
 * Failed → PUT {id}/status Archived; hidden from the default list, kept) · Restore (Archived → the
 * status it came from) · Delete (Draft / Canceled right away; Sent / Failed / Archived only after typing
 * the campaign name: DELETE {id}?confirm=name is permanent and removes its stats). "Select" turns on
 * checkboxes for the bulk bar (Archive selected / Delete selected drafts). "Archived" lists the
 * archived campaigns (status=Archived; the default list hides them).
 *
 * Managed tenants never see cost or spend: this page shows sales only, never stats.cost.
 */

const PAGE = 200;
const PILLS = [["all", "All"], ["drafts", "Drafts"], ["scheduled", "Scheduled"], ["sent", "Sent"]];
const GROUP = {
  Draft: "drafts",
  Scheduled: "scheduled",
  Approved: "scheduled",
  InReview: "scheduled",
  Sending: "scheduled",
  Sent: "sent",
  Completed: "sent"
};
const PILL_TONE = {
  Sent: "success",
  Completed: "success",
  Scheduled: "info",
  Approved: "info",
  Sending: "info",
  InReview: "warning",
  Paused: "warning",
  Failed: "danger",
  Rejected: "danger"
};

/** 38% / 4.1%: whole numbers from 10 up, one decimal below. */
function rate(v) {
  const n = Number(v);
  if (!isFinite(n)) return "0%";
  return `${n >= 10 ? Math.round(n) : Math.round(n * 10) / 10}%`;
}
function shortDate(v) {
  return v ? asDate(v).toLocaleDateString([], {
    month: "short",
    day: "numeric"
  }) : "";
}
function relative(v) {
  if (!v) return "";
  const d = asDate(v);
  const days = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(d.getTime()).setHours(0, 0, 0, 0)) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return `${days} days ago`;
  return shortDate(v);
}
/** Recurring campaigns: "Every week" / "Every month" from schedule.cadence.unit. */
function repeatLabel(c) {
  const cad = (parseMaybe(c && c.scheduleJson) || {}).cadence || {};
  const unit = String(cad.unit || "weekly").toLowerCase();
  return unit === "monthly" ? "Every month" : unit === "daily" ? "Every day" : "Every week";
}
function people(n) {
  return `${num(n)} ${Number(n) === 1 ? "person" : "people"}`;
}
/** The first image in the campaign's content, for the card thumbnail (null when there is none). */
function previewImage(c) {
  const raw = String(c && c.contentJson || "");
  const m = raw.match(/https?:(?:\\?\/){2}[^"'\s<>)]+?\.(?:png|jpe?g|gif|webp)(?:\?[^"'\s<>)\\]*)?/i);
  return m ? m[0].replace(/\\\//g, "/") : null;
}
class EmailCampaignsViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "outside", e => {
      if (this.state.menu && !(e.target.closest && e.target.closest(".ecl-menu-wrap"))) this.setState({
        menu: null
      });
    });
    _defineProperty(this, "esc", e => {
      if (e.key === "Escape" && this.state.menu) this.setState({
        menu: null
      });
    });
    _defineProperty(this, "load", async () => {
      const {
        range,
        rail,
        archived
      } = this.state;
      const r = rangeToApi(range);
      const status = archived ? "Archived" : "all";
      try {
        const [overview, list] = await Promise.all([api("GET", `/stats/overview${qs({
          range: r,
          compare: true,
          rail
        })}`).catch(() => null), api("GET", `/campaigns${qs({
          range: r,
          rail,
          status,
          $top: PAGE,
          $skip: 0
        })}`)]);
        if (!this._alive) return;
        this.setState({
          overview,
          rows: list && list.items || [],
          total: list && list.totalCount || 0,
          skip: 0,
          error: null
        });
      } catch (e) {
        if (this._alive) this.setState({
          error: errMsg(e, "Email campaigns could not be loaded."),
          rows: this.state.rows || []
        });
      }
    });
    _defineProperty(this, "more", async () => {
      const {
        range,
        rail,
        archived,
        skip,
        rows
      } = this.state;
      this.setState({
        loadingMore: true
      });
      try {
        const list = await api("GET", `/campaigns${qs({
          range: rangeToApi(range),
          rail,
          status: archived ? "Archived" : "all",
          $top: PAGE,
          $skip: skip + PAGE
        })}`);
        if (!this._alive) return;
        this.setState({
          rows: rows.concat(list && list.items || []),
          skip: skip + PAGE,
          loadingMore: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          loadingMore: false
        });
      }
    });
    _defineProperty(this, "setArchived", archived => this.setState({
      archived,
      group: "all",
      skip: 0,
      selected: {},
      confirm: null,
      bulk: null,
      menu: null
    }, this.load));
    _defineProperty(this, "open", id => () => this.props.history.push(`/Email/campaigns/detail/${idStr(id)}`));
    /** Row action: POST campaigns/{id}/duplicate, then open the new Draft in the editor. */
    _defineProperty(this, "duplicate", c => async e => {
      if (e) e.stopPropagation();
      const id = idStr(c.id);
      if (this.state.dupBusy) return;
      this.setState({
        dupBusy: id,
        menu: null
      });
      try {
        const d = await api("POST", `/campaigns/${id}/duplicate`, {});
        if (!this._alive) return;
        const newId = d && d.campaign && idStr(d.campaign.id);
        toast("Copied as a new draft.");
        if (newId) this.props.history.push(`/Email/campaigns/edit/${newId}`);else {
          this.setState({
            dupBusy: null
          });
          this.load();
        }
      } catch (err) {
        if (this._alive) this.setState({
          dupBusy: null,
          error: errMsg(err, "The campaign could not be copied.")
        });
      }
    });
    /** PUT campaigns/{id}/status: "Archived" to archive, or the status it was archived from to restore. */
    _defineProperty(this, "setStatus", (c, status, msg) => async e => {
      if (e) e.stopPropagation();
      const id = idStr(c.id);
      this.setState({
        busyId: id,
        confirm: null,
        menu: null
      });
      try {
        const r = await api("PUT", `/campaigns/${id}/status`, {
          status
        });
        if (!this._alive) return;
        toast(r && r.message || msg);
        this.setState({
          busyId: null
        });
        this.load();
      } catch (err) {
        if (this._alive) this.setState({
          busyId: null,
          error: errMsg(err, "The status could not be changed.")
        });
      }
    });
    /** DELETE campaigns/{id}[?confirm=name]. A 409 confirmRequired (a draft with sent children) upgrades the confirm to the typed-name one. */
    _defineProperty(this, "remove", (c, named) => async e => {
      if (e) e.stopPropagation();
      const id = idStr(c.id);
      this.setState({
        busyId: id
      });
      try {
        const r = await api("DELETE", `/campaigns/${id}${named ? `?confirm=${encodeURIComponent(this.state.typed.trim())}` : ""}`);
        if (!this._alive) return;
        toast(r && r.permanent ? `Deleted for good, with its ${num(r.recipients)} recipients and their activity.` : "Deleted.");
        const selected = {
          ...this.state.selected
        };
        delete selected[id];
        this.setState({
          busyId: null,
          confirm: null,
          typed: "",
          selected
        });
        this.load();
      } catch (err) {
        if (!this._alive) return;
        if (err.code === "confirmRequired") {
          this.setState({
            busyId: null,
            confirm: {
              id,
              named: true
            },
            typed: ""
          });
          return;
        }
        this.setState({
          busyId: null,
          confirm: null,
          error: errMsg(err, "The campaign could not be deleted.")
        });
      }
    });
    _defineProperty(this, "toggle", id => e => {
      e.stopPropagation();
      this.setState(s => {
        const selected = {
          ...s.selected
        };
        if (selected[id]) delete selected[id];else selected[id] = true;
        return {
          selected,
          bulk: null
        };
      });
    });
    _defineProperty(this, "toggleAll", ids => () => this.setState(s => {
      const all = ids.length > 0 && ids.every(k => s.selected[k]);
      const selected = {
        ...s.selected
      };
      ids.forEach(k => {
        if (all) delete selected[k];else selected[k] = true;
      });
      return {
        selected,
        bulk: null
      };
    }));
    /** Bulk bar: archive every selected campaign that can be archived; delete every selected Draft / Canceled (no history, so nothing to type). Others are skipped. */
    _defineProperty(this, "bulk", kind => async () => {
      const rows = (this.state.rows || []).map(r => r.campaign || {}).filter(c => this.state.selected[idStr(c.id)]);
      const targets = rows.filter(c => kind === "archive" ? canArchive(c) : c.status === "Draft" || c.status === "Canceled");
      this.setState({
        busyId: "bulk",
        bulk: null
      });
      let ok = 0,
        failed = 0;
      for (const c of targets) {
        try {
          if (kind === "archive") await api("PUT", `/campaigns/${idStr(c.id)}/status`, {
            status: "Archived"
          });else await api("DELETE", `/campaigns/${idStr(c.id)}`);
          ok++;
        } catch (err) {
          failed++;
        }
      }
      if (!this._alive) return;
      toast(`${kind === "archive" ? "Archived" : "Deleted"} ${num(ok)}${failed ? `, ${num(failed)} could not be changed` : ""}${rows.length > targets.length ? `, ${num(rows.length - targets.length)} skipped` : ""}.`);
      this.setState({
        busyId: null,
        selected: {}
      });
      this.load();
    });
    this.state = {
      overview: null,
      rows: null,
      total: 0,
      skip: 0,
      rail: "all",
      group: "all",
      archived: false,
      q: "",
      range: getGlobalRange(),
      error: null,
      loadingMore: false,
      dupBusy: null,
      busyId: null,
      confirm: null,
      typed: "",
      selected: {},
      selecting: false,
      bulk: null,
      menu: null,
      lists: {}
    };
    this._alive = true;
  }
  async componentDidMount() {
    refreshGuard().then(() => {
      if (this._alive !== false) this.forceUpdate();
    });
    document.addEventListener("mousedown", this.outside);
    document.addEventListener("keydown", this.esc);
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    this._tok = subscribePeriod(({
      range
    }) => {
      if (range && range !== this.state.range) this.setState({
        range,
        skip: 0
      }, this.load);
    });
    this.load();
    audienceApi("GET", "").then(d => {
      if (!this._alive) return;
      const lists = {};
      normalizeLists(d).forEach(l => {
        lists[l.id] = l.name;
      });
      this.setState({
        lists
      });
    }).catch(() => {/* list names are a nicety */});
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
    document.removeEventListener("mousedown", this.outside);
    document.removeEventListener("keydown", this.esc);
  }
  /** Inline confirm under the card: Draft / Canceled ask Yes, delete / Keep; Sent / Failed / Archived ask for the campaign name. */
  confirmBox(c, confirm, busy) {
    const {
      typed
    } = this.state;
    const ok = typed.trim().toLowerCase() === String(c.name || "").trim().toLowerCase();
    return /*#__PURE__*/React.createElement("div", {
      className: "ecl-confirm ec-confirm" + (confirm.named ? " ec-confirm--typed" : ""),
      onClick: e => e.stopPropagation()
    }, confirm.named ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      value: typed,
      placeholder: `Type “${c.name}” to delete`,
      "aria-label": "Campaign name",
      onChange: e => this.setState({
        typed: e.target.value
      })
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle danger",
      disabled: busy || !ok,
      onClick: this.remove(c, true)
    }, busy ? "…" : "Delete"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      disabled: busy,
      onClick: () => this.setState({
        confirm: null,
        typed: ""
      })
    }, "Keep"), /*#__PURE__*/React.createElement("span", {
      className: "ec-help"
    }, "This can't be undone. Its results, recipients and activity are removed from every report.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, c.status === "Draft" ? "Delete this draft?" : "Delete this canceled campaign?"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle danger",
      disabled: busy,
      onClick: this.remove(c, false)
    }, busy ? "…" : "Yes, delete"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      disabled: busy,
      onClick: () => this.setState({
        confirm: null
      })
    }, "Keep")));
  }

  /** The ··· menu: Open, Keep editing (drafts), Duplicate, Restore, Archive, Delete. */
  menu(c) {
    const id = idStr(c.id);
    const open = this.state.menu === id;
    const lock = !!this.state.busyId || !!this.state.dupBusy;
    const editable = c.status === "Draft" || c.status === "Rejected";
    return /*#__PURE__*/React.createElement("span", {
      className: "ecl-menu-wrap",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-more",
      "aria-label": "More actions",
      "aria-haspopup": "menu",
      "aria-expanded": open,
      onClick: () => this.setState({
        menu: open ? null : id
      })
    }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-menu",
      role: "menu"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: () => {
        this.setState({
          menu: null
        });
        this.open(c.id)();
      }
    }, "Open"), editable ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: () => this.props.history.push(`/Email/campaigns/edit/${id}`)
    }, "Edit") : null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      disabled: lock,
      onClick: this.duplicate(c)
    }, this.state.dupBusy === id ? "Copying…" : "Make a copy"), c.status === "Archived" ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      disabled: lock,
      onClick: this.setStatus(c, archivedFrom(c), "Restored.")
    }, "Restore") : null, canArchive(c) ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      disabled: lock,
      title: "Hide it from the list. Results are kept.",
      onClick: this.setStatus(c, "Archived", "Archived.")
    }, "Archive") : null, canDelete(c) ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      className: "danger",
      disabled: lock,
      onClick: () => this.setState({
        menu: null,
        confirm: {
          id,
          named: permanentDelete(c)
        },
        typed: ""
      })
    }, "Delete") : null) : null);
  }

  /** The plain line under the name. */
  line(r) {
    const c = r.campaign || {};
    const s = r.stats || {};
    const st = c.status;
    const sch = parseMaybe(c.scheduleJson) || {};
    const aud = parseMaybe(c.audienceJson) || {};
    const inc = (aud.include || []).map(idStr);
    const names = inc.map(k => this.state.lists[k]).filter(Boolean);
    const listText = names.length ? `${names[0]}${names.length > 1 ? ` and ${num(names.length - 1)} more` : ""}` : "";
    const count = Number(r.audienceCount) || 0;
    const local = String(sch.mode || "").toLowerCase() === "local";
    const when = c.sendAt ? `${dateTime(c.sendAt)}${local ? " in each person's time zone" : ""}` : "";
    const bits = [];
    const via = c.rail && c.rail !== "plunk" ? `via ${railLabel(c.rail)}` : null;
    switch (st) {
      case "Sent":
      case "Completed":
        bits.push(`Sent ${shortDate(r.sentAt || c.completedDate || c.sendAt)} to ${people(Number(s.sent) || count)}`);
        if (listText) bits.push(listText);
        break;
      case "Sending":
        {
          const sent = Number(s.sent) || 0;
          bits.push(count > 0 ? `Sending now, ${num(sent)} of ${num(count)} so far` : `Sending now, ${num(sent)} so far`);
          if (listText) bits.push(listText);
          break;
        }
      case "Scheduled":
        bits.push(when ? `Goes out ${when}` : "Scheduled");
        if (count) bits.push(people(count));
        if (listText) bits.push(listText);
        break;
      case "Approved":
        bits.push(when ? `Approved, goes out ${when}` : "Approved, ready to schedule");
        if (count) bits.push(people(count));
        break;
      case "InReview":
        bits.push("Waiting for approval");
        if (when) bits.push(`planned for ${when}`);
        if (count) bits.push(people(count));
        break;
      case "Draft":
        bits.push("Draft");
        if (listText) bits.push(listText);
        bits.push(`edited ${relative(c.modifiedDate || c.createdDate)}`);
        break;
      case "Paused":
        bits.push(`Paused after ${people(s.sent)}`);
        break;
      case "Failed":
        bits.push(c.lastError ? `Didn't go out: ${String(c.lastError).slice(0, 80)}` : "Didn't go out");
        break;
      case "Rejected":
        bits.push(c.rejectReason ? `Sent back: ${String(c.rejectReason).slice(0, 80)}` : "Sent back for changes");
        break;
      case "Canceled":
        bits.push(`Canceled ${relative(c.modifiedDate)}`);
        break;
      case "Archived":
        bits.push(`Archived${Number(s.sent) > 0 ? `, sent to ${people(s.sent)}` : ""}`);
        break;
      default:
        if (st) bits.push(statusLabel(st));
    }
    if (via) bits.push(via);
    if (c.rail === "constant_contact" && (st === "Scheduled" || st === "Sending")) bits.push("results update hourly");
    return bits.join(" · ");
  }

  /** A warning pill when a sent campaign is past the complaint or bounce limit. */
  warning(r) {
    const s = r.stats || {};
    const sent = Number(s.sent) || 0;
    if (!sent) return null;
    const hard = (Number(s.bouncedHard) || 0) / sent * 100;
    const g = guardState(s.complaintRate, hard);
    if (g === "hot") return /*#__PURE__*/React.createElement("span", {
      className: "ecl-pill ecl-pill--danger"
    }, Number(s.complaintRate) >= GUARD.complaintPct ? "Too many spam reports" : "Too many bounces");
    if (g === "warm") return /*#__PURE__*/React.createElement("span", {
      className: "ecl-pill ecl-pill--warning"
    }, Number(s.complaintRate) >= GUARD.complaintPct * GUARD.warnAtPct / 100 ? "Spam reports rising" : "Bounces rising");
    return null;
  }
  card(r) {
    const c = r.campaign || {};
    const s = r.stats || {};
    const id = idStr(c.id);
    const st = c.status;
    const group = GROUP[st];
    const sentAny = Number(s.sent) > 0;
    const img = previewImage(c);
    const {
      selecting,
      selected
    } = this.state;
    const confirm = this.state.confirm && this.state.confirm.id === id ? this.state.confirm : null;
    const kind = String(c.kind || "").toLowerCase();
    let right = null;
    if (group === "sent" || sentAny && st !== "Draft") {
      right = /*#__PURE__*/React.createElement("div", {
        className: "ecl-stats"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, rate(s.openRate)), " opened"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, rate(s.clickRate)), " clicked"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, money(s.revenue)), " sales"));
    } else if (st === "Draft" || st === "Rejected") {
      right = /*#__PURE__*/React.createElement(Link, {
        className: "ecl-btn",
        to: `/Email/campaigns/edit/${id}`,
        onClick: e => e.stopPropagation()
      }, "Keep going");
    } else if (group === "scheduled") {
      right = /*#__PURE__*/React.createElement(Link, {
        className: "ecl-btn",
        to: `/Email/campaigns/detail/${id}`,
        onClick: e => e.stopPropagation()
      }, "Open");
    }
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "ecl-card" + (selected[id] ? " on" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecl-row",
      role: "link",
      tabIndex: 0,
      onClick: selecting ? this.toggle(id) : this.open(c.id),
      onKeyDown: e => {
        if (e.key === "Enter") (selecting ? this.toggle(id) : this.open(c.id))(e);
      }
    }, selecting ? /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "ecl-check",
      "aria-label": `Select ${c.name}`,
      checked: !!selected[id],
      onClick: e => e.stopPropagation(),
      onChange: this.toggle(id)
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "ecl-thumb" + (st === "Draft" ? " ecl-thumb--draft" : ""),
      style: img ? {
        backgroundImage: `url("${img}")`
      } : null,
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "ecl-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecl-title"
    }, /*#__PURE__*/React.createElement("b", null, c.name || "Untitled"), /*#__PURE__*/React.createElement("span", {
      className: `ecl-pill ecl-pill--${PILL_TONE[st] || "neutral"} ecl-pill--status`
    }, statusLabel(st)), r.isAbTest || kind === "ab_test" ? /*#__PURE__*/React.createElement("span", {
      className: "ecl-pill ecl-pill--neutral"
    }, "A/B test") : null, kind === "recurring" ? /*#__PURE__*/React.createElement("span", {
      className: "ecl-pill ecl-pill--neutral"
    }, repeatLabel(c)) : null, kind === "resend" ? /*#__PURE__*/React.createElement("span", {
      className: "ecl-pill ecl-pill--neutral"
    }, "Resend") : null, this.warning(r)), /*#__PURE__*/React.createElement("span", {
      className: "ecl-line"
    }, this.line(r))), right, this.menu(c)), confirm ? this.confirmBox(c, confirm, this.state.busyId === id) : null);
  }
  tiles(overview) {
    const cur = overview && overview.current || {};
    const prev = overview && overview.previous;
    const d = overview && overview.delta || {};
    let days = 0;
    if (overview && overview.from && overview.to) days = Math.max(1, Math.round((asDate(overview.to) - asDate(overview.from)) / 86400000));
    const before = days ? `vs the ${num(days)} day${days === 1 ? "" : "s"} before` : "vs the period before";
    const cmp = (v, unit) => {
      if (!prev || v == null || !isFinite(Number(v))) return null;
      const n = Number(v);
      const t = unit === "pts" ? `${n > 0 ? "+" : ""}${Math.round(n * 10) / 10} pts` : `${n > 0 ? "+" : ""}${Math.round(n)}%`;
      return {
        text: `${t} ${before}`,
        up: n > 0,
        down: n < 0
      };
    };
    const orders = Number(cur.orders) || Number(cur.conversions) || 0;
    return [{
      l: "Sent",
      v: num(cur.sent),
      s: null,
      c: cmp(d.sent)
    }, {
      l: "Opened",
      v: rate(cur.openRate),
      s: people(cur.uniqueOpens),
      c: cmp(d.openRate, "pts")
    }, {
      l: "Clicked",
      v: rate(cur.clickRate),
      s: people(cur.uniqueClicks),
      c: cmp(d.clickRate, "pts")
    }, {
      l: "Sales",
      v: money(cur.revenue),
      s: orders ? `from ${num(orders)} order${orders === 1 ? "" : "s"} after a click` : null,
      c: cmp(d.revenue)
    }];
  }
  render() {
    if (!hasTenantFeature("emailAutomation")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Email isn't turned on for this workspace yet. Contact Plunk to turn it on."));
    }
    const {
      overview,
      rows,
      total,
      error,
      q,
      selected,
      bulk,
      busyId,
      group,
      archived,
      selecting
    } = this.state;
    if (error && !rows) return /*#__PURE__*/React.createElement(Error, {
      message: error
    });
    if (!rows) return /*#__PURE__*/React.createElement(Loader, null);

    // Outreach programs have their own tab; keep any outreach-kind rows out of this list.
    const campaigns = rows.filter(r => String((r.campaign || {}).kind || "").toLowerCase() !== "outreach");
    const counts = {
      all: campaigns.length,
      drafts: 0,
      scheduled: 0,
      sent: 0
    };
    campaigns.forEach(r => {
      const g = GROUP[(r.campaign || {}).status];
      if (g) counts[g]++;
    });
    const ql = q.trim().toLowerCase();
    const visible = campaigns.filter(r => (archived || group === "all" || GROUP[(r.campaign || {}).status] === group) && (!ql || `${(r.campaign || {}).name} ${r.subject || ""}`.toLowerCase().includes(ql)));
    const visibleIds = visible.map(r => idStr((r.campaign || {}).id));
    const selectedRows = visible.map(r => r.campaign || {}).filter(c => selected[idStr(c.id)]);
    const nSel = selectedRows.length,
      nArch = selectedRows.filter(canArchive).length,
      nDel = selectedRows.filter(c => c.status === "Draft" || c.status === "Canceled").length;
    const allOn = visibleIds.length > 0 && visibleIds.every(k => selected[k]);
    const cur = overview && overview.current || {};
    const nothingYet = !archived && !campaigns.length && !(Number(cur.sent) > 0);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view ec-view ec-home ecl-view"
    }, /*#__PURE__*/React.createElement(EmailHeader, null), error ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice danger"
    }, error) : null, nothingYet ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-empty"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecl-empty-icon",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "26",
      height: "26",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "5",
      width: "18",
      height: "14",
      rx: "2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3 7l9 6 9-6"
    }))), /*#__PURE__*/React.createElement("b", null, this.state.range === "all_time" ? "No campaigns yet" : "No campaigns in this date range"), /*#__PURE__*/React.createElement("span", null, this.state.range === "all_time" ? "Send one email to a list, now or on a date. It takes a few minutes." : "Older campaigns may be outside the dates picked at the top."), /*#__PURE__*/React.createElement("div", {
      className: "ecl-empty-actions"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "ecl-btn ecl-btn--primary",
      to: "/Email/campaigns/new"
    }, "Start a campaign"), this.state.range === "all_time" ? null : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-btn",
      onClick: () => setGlobalRange("all_time")
    }, "Show all campaigns"))) : /*#__PURE__*/React.createElement(React.Fragment, null, overview ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-tiles"
    }, this.tiles(overview).map(t => /*#__PURE__*/React.createElement("div", {
      key: t.l,
      className: "ecl-tile"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecl-tile-l"
    }, t.l), /*#__PURE__*/React.createElement("b", {
      className: "ecl-tile-v"
    }, t.v), t.s ? /*#__PURE__*/React.createElement("span", {
      className: "ecl-tile-s"
    }, t.s) : null, t.c ? /*#__PURE__*/React.createElement("span", {
      className: "ecl-tile-s" + (t.c.up ? " up" : "")
    }, t.c.text) : null))) : /*#__PURE__*/React.createElement("div", {
      className: "ecl-note"
    }, "Totals aren't available right now. Try again in a minute."), /*#__PURE__*/React.createElement("div", {
      className: "ecl-toolbar"
    }, archived ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-pills"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-fpill on"
    }, "Archived ", num(campaigns.length)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-link",
      onClick: () => this.setArchived(false)
    }, "Back to all campaigns")) : /*#__PURE__*/React.createElement("div", {
      className: "ecl-pills",
      role: "tablist",
      "aria-label": "Filter campaigns"
    }, PILLS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "tab",
      "aria-selected": group === k,
      className: "ecl-fpill" + (group === k ? " on" : ""),
      onClick: () => this.setState({
        group: k,
        selected: {},
        bulk: null
      })
    }, l, " ", num(k === "all" ? rows.length < total ? total : counts.all : counts[k])))), /*#__PURE__*/React.createElement("span", {
      className: "ecl-spacer"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-link",
      onClick: () => this.setState({
        selecting: !selecting,
        selected: {},
        bulk: null
      })
    }, selecting ? "Done" : "Select"), !archived ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-link",
      onClick: () => this.setArchived(true)
    }, "Archived") : null, /*#__PURE__*/React.createElement("label", {
      className: "ecl-search"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "search"), /*#__PURE__*/React.createElement("input", {
      type: "search",
      value: q,
      placeholder: "Search campaigns",
      "aria-label": "Search campaigns",
      onChange: e => this.setState({
        q: e.target.value
      })
    }))), selecting ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-bulkbar"
    }, /*#__PURE__*/React.createElement("label", {
      className: "ecl-all"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: allOn,
      onChange: this.toggleAll(visibleIds)
    }), " All shown"), /*#__PURE__*/React.createElement("span", {
      className: "cnt"
    }, num(nSel), " selected"), bulk === "delete" ? /*#__PURE__*/React.createElement("span", {
      className: "ec-confirm"
    }, /*#__PURE__*/React.createElement("span", null, "Delete ", num(nDel), " draft or canceled campaign", nDel === 1 ? "" : "s", "? Selected campaigns that already went out are skipped."), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle danger",
      disabled: !!busyId,
      onClick: this.bulk("delete")
    }, "Yes, delete"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      disabled: !!busyId,
      onClick: () => this.setState({
        bulk: null
      })
    }, "Keep")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle",
      disabled: !!busyId || !nArch,
      title: "Sent, canceled, draft and failed campaigns. The rest are skipped.",
      onClick: this.bulk("archive")
    }, busyId === "bulk" ? "…" : `Archive selected${nArch < nSel ? ` (${num(nArch)})` : ""}`), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "territory-toggle danger",
      disabled: !!busyId || !nDel,
      title: "Drafts and canceled campaigns only. To delete one that went out, use its \xB7\xB7\xB7 menu.",
      onClick: () => this.setState({
        bulk: "delete"
      })
    }, "Delete selected drafts", nDel ? ` (${num(nDel)})` : ""))) : null, !visible.length ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-note"
    }, archived ? "No archived campaigns. Archiving hides a campaign and keeps its results; restore it here any time." : ql ? "No campaign matches your search." : group !== "all" ? `No ${group === "drafts" ? "drafts" : group === "scheduled" ? "scheduled campaigns" : "sent campaigns"} in this period.` : "No campaigns in this period.") : /*#__PURE__*/React.createElement("div", {
      className: "ecl-list"
    }, visible.map(r => this.card(r))), rows.length < total ? /*#__PURE__*/React.createElement("div", {
      className: "ecl-more-row"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecl-link",
      disabled: this.state.loadingMore,
      onClick: this.more
    }, this.state.loadingMore ? "Loading…" : `Show ${num(Math.min(PAGE, total - rows.length))} more`)) : null));
  }
}
export default withRouter(EmailCampaignsViewComponent);